export const SET_TOKEN = 'SET_TOKEN'
export const DELETE_TOKEN = 'DELETE_TOKEN'
export const SET_PASSWORD_RESET_TOKEN = 'SET_PASSWORD_RESET_TOKEN'
export const DELETE_PASSWORD_RESET_TOKEN = 'DELETE_PASSWORD_RESET_TOKEN'

export default {
  SET_TOKEN,
  DELETE_TOKEN,
  SET_PASSWORD_RESET_TOKEN,
  DELETE_PASSWORD_RESET_TOKEN
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutation-types.js